import { LoadingState } from "..";

export class LoadingStateHelper {
  static generate(errored: boolean, isLoading: boolean, isLoaded: boolean): LoadingState {
    return {
      errored,
      isLoaded,
      isLoading
    };
  }
}
